export const formatDate = (date) => {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formatedDate = new Date(date);
  return formatedDate.toLocaleDateString("en-US", options);
};

export const formatDateGB = (date, options) => {
  const formatedDate = new Date(date);
  return formatedDate.toLocaleDateString("en-GB", options).replaceAll("/", ".");
};

// Used in DateCard
export const formatDateAndTime = (date) => {
  const formattedDate = new Date(date);
  const day = formattedDate.getDate();
  const month = formattedDate.toLocaleDateString('en-GB', { month: 'long' });
  const formattedDay = day < 10 ? `0${day}` : day;
  const hour = formattedDate.getHours();
  const formattedHour = hour < 10 ? `0${hour}` : hour;
  const minutes = formattedDate.getMinutes(); 
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedTime = `${formattedHour}${formattedMinutes === '' ? '' : `:${formattedMinutes}`}`;
  const formattedTimeWithAmPm = `${formattedTime}${hour >= 12 ? "PM" : "AM"}`;

  return {
    day: formattedDay,
    month,
    hour: formattedHour,
    minutes: formattedMinutes,
    time: formattedTime,
    timeWithAmPm: formattedTimeWithAmPm
  };
}
